import {
  FETCH_DISTRICS_LIST_REQUEST,
  FETCH_DISTRICS_LIST_SUCCESS,
  FETCH_DISTRICS_LIST_FAILURE,
  SET_CURRENT_DISTRICT,
  FETCH_PREFIXES_REQUEST,
  FETCH_PREFIXES_SUCCESS,
  FETCH_PREFIXES_FAIL,
} from '../constants';

import fetch from '../core/fetch';
import _ from 'lodash';

export function fetchDistrictList() {
  return function (dispatch) {
    dispatch({ type: FETCH_DISTRICS_LIST_REQUEST });
    return fetch(`${process.env.API_URL}/app_district`, {
      method: 'GET',
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      }
      dispatch({ type: FETCH_DISTRICS_LIST_FAILURE });
      throw response;
    })
    .then((r) => {
      dispatch({ type: FETCH_DISTRICS_LIST_SUCCESS, payload: r.districts });
      return r.districts;
    })
    .catch(async error => {
      // let err = await error.text();
      console.info(error);
    });
  };
}

export function setCurrentDistrict(teryt) {
  return function (dispatch, getState) {
    const regDistricts = getState().admin.regDistricts;
    if (!regDistricts.areDistrictsFetched) {
      dispatch(fetchDistrictList()).then(() => {
        const newState = getState().admin.regDistricts;
        dispatch({ type: SET_CURRENT_DISTRICT, payload: _.find(newState.districtsList, v => v.teryt == teryt) });
      });
    }
  };
}

export function fetchPrefixes() {
  return function (dispatch) {
    dispatch({ type: FETCH_PREFIXES_REQUEST });
    const fetchPrefixes = `${process.env.API_URL}/prefixes`;
    fetch(fetchPrefixes)
      .then(r => {
        if (r.status === 200) {
          return r.json();
        }
        dispatch({ type: FETCH_PREFIXES_FAIL });
      })
      .then(resp => {
        dispatch({ type: FETCH_PREFIXES_SUCCESS, payload: resp.prefixes });
      });
  };
}



// WEBPACK FOOTER //
// src/actions/app.js